import { GoogleOrder, HgsCartItem } from "../types";

export enum EventAction {
  ACTIVATION = "activation",
  LAUNCH = "launch",
}

export interface AddToCartProps {
  ecomm_prodid: string[];
  ecomm_pagetype: string;
  ecomm_totalvalue: number;
  revenue_value: number;
  currency: string;
  items: BingProductItem[];
}
export interface BingOrder {
  transaction_id: string;
  ecomm_prodid: string[];
  ecomm_pagetype: string;
  ecomm_totalvalue: number;
  revenue_value: number;
  currency: string;
  items: BingProductItem[];
}

export interface BingProductItem {
  id: string;
  quantity: number;
  price: number;
}

type BingEventQueue = {
  push(...items: unknown[]): unknown;
};

declare global {
  interface Window {
    uetq?: BingEventQueue;
  }
}

function getEventQueue(): BingEventQueue {
  window.uetq = window.uetq || [];
  return window.uetq;
}

function add_to_cart(product: AddToCartProps): void {
  getEventQueue().push("event", "add_to_cart", product);
}

export function triggerAddToCartEvent(itemsObject: HgsCartItem) {
  const totalPrice = Math.round(itemsObject.price * itemsObject.quantity * 100) / 100;
  const product: AddToCartProps = {
    ecomm_prodid: [itemsObject.item_id],
    ecomm_pagetype: "product",
    ecomm_totalvalue: totalPrice,
    revenue_value: totalPrice,
    currency: "USD",
    items: [
      {
        id: itemsObject.item_id,
        quantity: itemsObject.quantity,
        price: itemsObject.price,
      },
    ],
  };
  add_to_cart(product);
}

function purchase(order: BingOrder): void {
  getEventQueue().push("event", "purchase", order);
}

export function triggerCheckoutCompleteEvent(order: GoogleOrder) {
  const bOrder: BingOrder = {
    transaction_id: order.transaction_id,
    ecomm_prodid: order.items.map((i) => {
      return i.item_id;
    }),
    ecomm_pagetype: "purchase",
    ecomm_totalvalue: order.value,
    revenue_value: order.value,
    currency: order.currency,
    items: order.items.map((i) => {
      return {
        id: i.item_id,
        quantity: i.quantity,
        price: i.price,
      };
    }),
  };

  purchase(bOrder);
}
